import styled from "@emotion/styled";

import { ResponsiveBreakpoint, ResponsiveBreakpointType } from "constants/responsive-breakpoint";
import { withPx } from "themes/helpers";

export const StyledContainer = styled.div`
  padding-block: 10px;
  display: flex;
  flex: 0 0 auto;
`;

export const BackButtonContainer = styled.div`
  display: none;
  padding: 8px;
  @media (max-width: ${withPx(ResponsiveBreakpoint[ResponsiveBreakpointType.Mobile])}) {
    display: inline-block;
    height: 36px;
  }
`;

export const CloseButtonContainer = styled.div`
  cursor: pointer;
  display: inline-block;
  padding: 18px 8px 8px;
  margin-right: 10px;
  @media (max-width: ${withPx(ResponsiveBreakpoint[ResponsiveBreakpointType.Mobile])}) {
    display: none;
  }
`;

export const WidgetsContainer = styled.div`
  @media (max-width: ${withPx(ResponsiveBreakpoint[ResponsiveBreakpointType.Mobile])}) {
    display: inline-block;
    white-space: nowrap;
    overflow: scroll;
  }

  display: flex;
  flex-direction: column;
`;

export const StyledWidget = styled.span<{
  isSelected: boolean;
  iconUrl?: string;
}>`
  cursor: pointer;
  display: inline-block;
  vertical-align: bottom;
  text-align: center;
  margin-top: 10px;

  &.with-icon {
    width: 20px;
    height: 20px;
    background: url(${(props): string => props.iconUrl ?? "none"}) 50% 50% / contain no-repeat;
    margin-bottom: 10px;
    position: relative;

    &:after {
      content: "";
      position: absolute;
      bottom: -10px;
      left: 0;
      right: 0;
      height: 5px;
      background: ${(props): string => (props.isSelected ? props.theme.linkColor : props.theme.backgroundColor)};
    }
  }

  &.without-icon {
    width: 20px;
    height: 18px;
    padding: 13px 8px 9px 8px;
    border-bottom: 5px solid
      ${(props): string => (props.isSelected ? props.theme.linkColor : props.theme.backgroundColor)};
  }
`;
